import { useParams, useNavigate, useLocation } from "react-router-dom";
import React, { useState, useContext, useEffect } from "react";
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { AppContext } from "../../context/AppContext";
import Swal from "sweetalert2";
import axios from "axios";
import GetToken from "../../GetToken";
import { handleInvalidToken } from "../../AuthUtils";
import AnimationSpinner from '../../AnimationSpinner';
import {toast} from "react-toastify"

// React icons import
import { IoIosArrowRoundForward, IoMdSettings } from "react-icons/io";

// Material UI import
import Button from "@mui/material/Button";

// bootstrap import
import { Card } from "react-bootstrap";
import ErrorComponent from "../NoDataFound.jsx/NoError";

import EmptyIcon from "../../assets/images/error-image.jpg";

const CreateTemplate = () => {
  const [loading, setLoading] = useState(false);
  const [items, setItems] = useState([]);
  const { base_url } = useContext(AppContext);
  const navigate = useNavigate();
 
  const fetchPageData = async (isLoadMore = false) => {
    try {
      const token = GetToken();
      if (!token) {
        handleInvalidToken(navigate);
        return;
      }
      setLoading(true);
      const formData = new FormData();
      formData.append("action", "getDefaultBookCovers");
      formData.append("token", token);

      const response = await axios.post(`${base_url}api/user/get-user-resource`, formData);

      if (response.data.status) {
        const fetchedTemplates = response.data.items || [];
        setItems(fetchedTemplates);

        setTimeout(() => {
          setLoading(false);
        }, 1500);
      } else {
        setLoading(false);
        if (response.data.reset) {
          handleInvalidToken(navigate);
          return;
        }
        toast.warning(response.data.message)
        // Swal.fire({
        //   icon: "warning",
        //   title: "Warning",
        //   text: response.data.message,
        // });
      }
    } catch (error) {
      setLoading(false);
      toast.error(error.response?.data?.message ||
        error.message ||
        "Something went wrong. Please try again.",)
      // Swal.fire({
      //   icon: "error",
      //   title: "Error",
      //   text:
      //     error.response?.data?.message ||
      //     error.message ||
      //     "Something went wrong. Please try again.",
      // });
    }
  };

  useEffect(() => {
    fetchPageData();
  }, []);

  const handleBookCover = (slug) => {
    const bookURL = `${base_url}book/cover/design/?image=${base_url}${slug}`;
    window.open(bookURL, "_blank");
  };


  return (
    <>
      <AnimationSpinner show={loading} />
      <div className="right-container">
        <div className="row align-items-center">
          <div className="col-lg-6 page-title-container">
            <h4 className="fw-semibold mb-1"> Create Book Cover</h4>
            <p className="mb-1">Create and customize template as you want </p>
          </div>
          <div className="col-lg-6 justify-content-end">
            <div className="d-flex justify-content-end gap-4">
              <Button
                onClick={() => navigate('/manage/book/templates')}
                variant="contained"
                color="secondary"
                title="Manage Book Covers"
                className="ms-2"
                sx={{
                  minWidth: "35px",
                  height: "38px",
                  padding: "0 17px",
                }}
              >
                <IoMdSettings fontWeight={600} color="white" style={{marginRight:"5px"}}/>
                Manage Book Covers
              </Button>
            </div>
          </div>
        </div>
     {items.length > 0 ? (
           <div className="row mt-5 ms-4">
           {items.map((item, index) => (
             <div className="col-md-3 mb-3" key={index}>
               <Card className="custom-card">
                 <div className="custom-card__image-container">
                   <img
                     src={base_url + item.tem_image_name}
                     alt="template"
                     className="custom-card__img"
                   /> 
                   <div className="custom-card__overlay">
                     <Button variant="contained" onClick={() => handleBookCover(item.tem_json_name)} className="custom-card__choose-btn">Choose</Button>
                   </div>
                 </div>
               </Card>
             </div>
           ))}
         </div>
     ) :
      (<ErrorComponent image={EmptyIcon} description={"No book cover templates available in page."} />)
    }
      </div>
    </>
  )
}

export default CreateTemplate